import { Link } from 'react-router-dom';

const footerLinks = {
  category: {
    title: '内容分类',
    items: [
      { label: '少女穿搭', path: '/category/fashion' },
      { label: '少女美妆', path: '/category/beauty' },
      { label: '少女生活', path: '/category/lifestyle' },
      { label: '少女社群', path: '/category/community' },
    ],
  },
  about: {
    title: '关于我们',
    items: [
      { label: '品牌故事', path: '/about' },
      { label: '用户口碑', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
      { label: '常见问题', path: '/about#faq' },
    ],
  },
};

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-bookmark-line', label: '小红书', href: '#' },
  { icon: 'ri-music-line', label: '抖音', href: '#' },
  { icon: 'ri-tv-line', label: 'B站', href: '#' },
  { icon: 'ri-wechat-line', label: '微信公众号', href: '#' },
];

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9tauvjpv18futdmiap0';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="container-custom py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="inline-block whitespace-nowrap cursor-pointer">
              <span className="text-2xl font-heading font-bold text-background-50">少女领域</span>
            </Link>
            <p className="mt-4 text-sm text-accent-200 leading-relaxed max-w-xs">
              专属少女的梦幻世界，汇聚少女风格的时尚、美妆、生活方式与兴趣内容，让青春与梦想在这里自由绽放。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-800 hover:bg-accent-700 text-background-50 transition-colors duration-200 cursor-pointer"
                  aria-label={s.label}
                  rel="nofollow"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-accent-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-4">订阅少女日报</h4>
            <p className="text-sm text-accent-200 mb-4">
              每周精选少女穿搭、美妆、好物内容，让你的少女心永不掉线~
            </p>
            <form
              className="flex flex-col sm:flex-row gap-2"
              id="newsletter-footer"
              data-readdy-form="true"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get('website_alt');
                if (honeypot && String(honeypot).trim() !== '') {
                  const msg = document.getElementById('nl-footer-msg');
                  if (msg) msg.textContent = '订阅成功！感谢你的关注~';
                  return;
                }
                formData.delete('website_alt');

                try {
                  const params = new URLSearchParams();
                  formData.forEach((v, k) => {
                    params.append(k, String(v));
                  });
                  const res = await fetch(NEWSLETTER_FORM_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                  });
                  const text = await res.text();
                  const msg = document.getElementById('nl-footer-msg');
                  if (res.ok) {
                    if (msg) msg.textContent = '订阅成功！感谢你的关注~';
                    form.reset();
                  } else {
                    if (msg) msg.textContent = '订阅出错了，请稍后再试~';
                  }
                } catch {
                  const msg = document.getElementById('nl-footer-msg');
                  if (msg) msg.textContent = '订阅出错了，请稍后再试~';
                }
              }}
            >
              <div className="website-alt-wrapper">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                placeholder="输入你的邮箱地址"
                className="flex-1 px-4 py-2.5 rounded-lg text-sm bg-accent-800 border border-accent-700 text-background-50 placeholder:text-accent-300 focus:outline-none focus:border-accent-400 transition-colors"
                required
              />
              <button
                type="submit"
                className="px-6 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
            </form>
            <p id="nl-footer-msg" className="text-sm text-accent-200 mt-2"></p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-accent-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-accent-300">
            &copy; {new Date().getFullYear()} 少女领域 Shoujo Domain. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-xs text-accent-300">
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}